<template>
  <div v-if="otpAccessToken" id="patient-area">
    <div v-show="!errorMsg">
      <Common v-on:activePage="setActivePage" v-on:loaded="onLoaded"/>
      <PatientMenu
        v-on:setActivePage="setActivePage"
        v-on:setActiveHomeCareTab="setActiveHomeCareTab"
        v-on:setActiveBasicTab="setActiveBasicTab"
        v-on:setTargetScrollPosition="setTargetScrollPosition"
        :activePage="activePage"
        :activeBasicTab="activeBasicTab"
        :listTabBasic="listTabBasic"
        :activeHomeCareTab="activeHomeCareTab"
        :listTabHomeCare="listTabHomeCare"
        :listTabHomeCareHaveData="listTabHomeCareHaveData"
      />
      <div :class="[activePage === 'graph' ? 'show' : 'none']">
        <Chart
          v-on:setLoadedBasicInfo="setLoadedBasicInfo"
          v-on:setExportChartPDF="setExportChartPDF"
          :isLoadedBasicInfo="isLoadedBasicInfo"
          :isExportChartPDF="isExportChartPDF"
        />
      </div>
      <div :class="[activePage === 'sleep-management' ? 'show' : 'none']">
        <SleepManagement :activePage="activePage"/>
      </div>
      <div :class="[activePage === 'video' ? 'show' : 'none']">
        <VideoList :activePage="activePage"/>
      </div>
      <div :class="[activePage === 'graph-seizure-change-rate' ? 'show' : 'none']">
        <SeizureChangeRate />
      </div>
      <div :class="[activePage === 'basic-information' ? 'show' : 'none']">
        <BasicInformation
          v-on:setLoadedBasicInfo="setLoadedBasicInfo"
          v-on:setExportAllergyPDF="setExportAllergyPDF"
          :activePage="activePage"
          :activeTab="activeBasicTab"
          :isLoadedBasicInfo="isLoadedBasicInfo"
          :isExportAllergyPDF="isExportAllergyPDF"
        />
      </div>
      <div :class="[activePage === 'medication-status' ? 'show' : 'none']">
        <MedicationStatus :activePage="activePage" />
      </div>
      <div :class="[activePage === 'vaccination' ? 'show' : 'none']">
        <Vaccination
          v-on:setLoadedBasicInfo="setLoadedBasicInfo"
          v-on:setExportVaccinPDF="setExportVaccinPDF"
          :activePage="activePage"
          :isExportVaccinPDF="isExportVaccinPDF"
          :isLoadedBasicInfo="isLoadedBasicInfo"
        />
      </div>
      <div v-if="$store.state.auth.typeOfUser !== 'pharmacy'" :class="[activePage === 'home-care-note-book' ? 'show' : 'none']">
        <HomeCareNotebook
          v-on:setListTabHomeCareHaveData="setListTabHomeCareHaveData"
          v-on:setActiveHomeCareTab="setActiveHomeCareTab"
          v-on:setLoadedBasicInfo="setLoadedBasicInfo"
          v-on:setExportHomecarePDF="setExportHomecarePDF"
          v-on:setLoading="setLoading"
          :activePage="activePage"
          :listTab="listTabHomeCare"
          :activeTab="activeHomeCareTab"
          :listTabHomeCareHaveData="listTabHomeCareHaveData"
          :isLoadedBasicInfo="isLoadedBasicInfo"
          :isExportHomecarePDF="isExportHomecarePDF"
        />
      </div>
    </div>
    <ErrorDialog :content="$t('the_use_of_otp_was_not_permitted')"/>
    <NoticeExportPDFDialog
      v-on:setExportHomecarePDF="setExportHomecarePDF"
      v-on:setExportVaccinPDF="setExportVaccinPDF"
      v-on:setExportAllergyPDF="setExportAllergyPDF"
      v-on:setExportChartPDF="setExportChartPDF"
      :activePage="activePage"
    />
  </div>

</template>

<script>
  import Common from './Common'
  import Chart from './Chart'
  import SleepManagement from './SleepManagement'
  import VideoList from './VideoList'
  import SeizureChangeRate from './SeizureChangeRate'
  import PatientMenu from'./PatientMenu.vue'
  import BasicInformation from './BasicInformation'
  import MedicationStatus from './MedicationStatus'
  import Vaccination from './Vaccination'
  import HomeCareNotebook from './HomeCareNotebook'
  import ErrorDialog from '@/js/components/Common/ErrorDialog'
  import NoticeExportPDFDialog from '@/js/components/Common/NoticeExportPDFDialog'
  import { BModal, VBModal, BButton } from 'bootstrap-vue'
  import { mapState, mapGetters } from 'vuex'
  import { getOffset, HEADER_ELEMENT_HEIGHT, SPACE_PATIENT_TAB_AREA_WITH_TOP } from '@/js/commons/commons'

  export default {
    components: {
      Common,
      Chart,
      SleepManagement,
      VideoList,
      BModal,
      BButton,
      ErrorDialog,
      NoticeExportPDFDialog,
      SeizureChangeRate,
      PatientMenu,
      BasicInformation,
      MedicationStatus,
      Vaccination,
      HomeCareNotebook,
    },
    data() {
      return {
        patientElement: null,
        activePage: '',
        activeBasicTab: 'seizure_info',
        activeHomeCareTab: 'tube_feeding',
        commonElementHeight: 0,
        listTabBasic: ['seizure_info', 'allergy', 'medical_history', 'visitted_hospital'],
        listTabHomeCare: ['tube_feeding', 'suction', 'oxygen', 'center_nutrition', 'dialysis', 'peritoneal_dialysic', 'ventilator', 'insulin'],
        listTabHomeCareHaveData: [],
        targetScrollPosition: null,
        isLoadedBasicInfo: false,
        isExportChartPDF: false,
        isExportHomecarePDF: false,
        isExportVaccinPDF: false,
        isExportAllergyPDF: false,
      }
    },
    mounted() {
      this.screenTracking(this.$t('patient_information'))
      if (this.$store.state.auth.typeOfUser == 'doctor-nanamedi' && !this.otpAccessToken && this.$store.state.patient.info.id) {
        this.$router.push({ path: 'patient/' + this.$store.state.patient.info.id })
      }
      this.patientElement = document.getElementById('patient-area')
      if(this.patientElement) {
        window.addEventListener('scroll', this.handleActiveTab);
        window.addEventListener('resize', this.handleActiveTab);
        this.patientElement.closest('#m-right-col').style.overflow = 'initial'
      }
    },
    beforeDestroy () {
      window.removeEventListener('scroll', this.handleActiveTab);
      window.removeEventListener('resize', this.handleActiveTab);
    },
    watch: {
      listTabHomeCareHaveData() {
        if( this.activeHomeCareTab === '') {
          this.activeHomeCareTab = this.listTabHomeCareHaveData.length > 0 ? this.listTabHomeCareHaveData[0] : ''
        }
      },
      targetScrollPosition() {
        if(this.targetScrollPosition != null) {
          this.handleActiveTab()
        }
      }
    },
    computed: {
      ...mapState({
        errorMsg: state => state.patient.errorMsg,
        otpAccessToken: state => state.otp.otpAccessToken,
        otpLoading: state => state.otp.otpLoading,
        otpChildId: state => state.otp.childId,
        visited_hospital: state => state.homeCareBook.visited_hospital,
      })
    },
    methods: {
      handleActiveTab() {
        if(this.targetScrollPosition == null) {
          this.checkTabActive()
        }
        else if (
          (this.targetScrollPosition == Math.floor(window.scrollY))
          || (
            this.targetScrollPosition > Math.floor(window.scrollY) 
            && document.documentElement.offsetHeight + document.documentElement.scrollTop >= document.documentElement.scrollHeight
          )
        ) {
          this.setTargetScrollPosition(null)
        }
      },
      setLoading(data) {
        this.isLoading = data
      },
      setExportChartPDF(data) {
        this.isExportChartPDF = data
      },
      setExportHomecarePDF(data) {
        this.isExportHomecarePDF = data
      },
      setExportVaccinPDF(data) {
        this.isExportVaccinPDF = data
      },
      setExportAllergyPDF(data) {
        this.isExportAllergyPDF = data
      },
      setTargetScrollPosition(data) {
        this.targetScrollPosition = data
      },
      setLoadedBasicInfo(data) {
        this.isLoadedBasicInfo = data
      },
      setActiveBasicTab(data) {
        this.activeBasicTab = data
      },
      setActiveHomeCareTab(data) {
        this.activeHomeCareTab = data
      },
      setListTabHomeCareHaveData (data) {
        this.listTabHomeCareHaveData = data
      },
      getPositionOfListTab(activePage) {
        let result = []
        let heightOfMenuPatientElement = document.getElementsByClassName('patient-menu')[0].offsetHeight
        let list = activePage === 'basic-information' ? this.listTabBasic : this.listTabHomeCareHaveData
        list.forEach((tab, index) => {
          result[index] = index == 0 ? 0 : (getOffset(document.getElementById(tab)).top - Math.floor(heightOfMenuPatientElement + HEADER_ELEMENT_HEIGHT + SPACE_PATIENT_TAB_AREA_WITH_TOP))
        })
        return result
      },
      checkTabActive() {
        if(this.activePage === 'basic-information' || this.activePage === 'home-care-note-book') {
          if(window.scrollY == 0) {
            this.activeBasicTab = this.listTabBasic[0],
            this.activeHomeCareTab = this.listTabHomeCareHaveData[0] || ''
          }
          else if (document.documentElement.offsetHeight + document.documentElement.scrollTop >= document.documentElement.scrollHeight) {  
            this.activeBasicTab = this.listTabBasic[this.listTabBasic.length - 1],
            this.activeHomeCareTab = this.listTabHomeCareHaveData[this.listTabHomeCareHaveData.length - 1] || ''
          }
          else {
            let scrollPositionY = Math.floor(window.scrollY)
            let listTabPosition = this.getPositionOfListTab(this.activePage)
            for(let i = (listTabPosition.length - 1) ; i >= 0; i--) {
              if((listTabPosition[i]) <= scrollPositionY) {
                if(this.activePage === 'basic-information' && this.activeBasicTab != this.listTabBasic[i]) {
                  this.activeBasicTab = this.listTabBasic[i]
                }
                else if (this.activePage === 'home-care-note-book' && this.activeHomeCareTab != this.listTabHomeCareHaveData[i]) {
                  this.activeHomeCareTab = this.listTabHomeCareHaveData[i]
                }
                break
              }
            }
          }
        }     
      },
      setActivePage(val) {
        this.activePage = val
        window.scrollTo(0,0)
        if(val === 'basic-information') this.activeBasicTab = this.listTabBasic[0]
        else if(val === 'home-care-note-book') this.activeHomeCareTab = this.listTabHomeCareHaveData.length > 0 ? this.listTabHomeCareHaveData[0] : ''
      },
      onLoaded() {
        if (this.errorMsg && this.otpAccessToken && !this.otpLoading) {
          this.$bvModal.show('modal-error')
        }
        else {
          this.setActivePage('graph')
        }
      },
    }
  }
</script>